export const GET_USER_ACTION = 'getAllUsers';
export const GET_SUPPLIERS_ACTION = 'getAllSuppliers';
export const GET_SUPPLIER_BY_CREDITOR_ID_ACTION = 'getSupplierById';
export const GET_ADMIN_DEMANDS = 'loadAdminDemands';
export const GET_DEMANDS_BY_DEMAND_IDS = 'getDemandsByDemandIds';
export const GET_OFFERS_BY_OFFER_IDS = 'getOffersByOfferIds';
export const GET_DEMANDS_GROUPED_BY_SKU = 'loadDemandsGroupedBySku';
export const CANCEL_DEMAND_ACTION = 'cancelDemandAction';
export const LOAD = 'load';
export const RELOAD = 'reload';
export const DOWNLOAD = 'download';
export const DOWNLOADGROUPED = 'downloadGrouped';

export const PURCHASEOFFERS = {
  CREATE: 'create',
  ACCEPT: 'accept',
  BLOCK: 'block',
  UNBLOCK: 'unblock',
  FAIL: 'fail',
  REJECT: 'reject',
};

export const DEMANDS = {
  CREATE: 'create',
  CANCEL: 'cancel',
  FULFILL: 'fulfill',
  REQUEST: 'request',
  UNREQUEST: 'unrequest',
};
